import { Component, OnInit } from '@angular/core';
import { ObAccountModel } from 'src/app/models/ob-account.model';
import { ObAffordabilityModel } from 'src/app/models/ob-affordability.model';
import { ObInstitutionModel } from 'src/app/models/ob-institution.model';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { logError } from 'src/app/sentry';
import { OpenBankingService } from 'src/app/services/open-banking.service';
import { QuestionService } from 'src/app/services/question.service';
import { OpenBankingMode } from '../apg-open-banking-institutions/apg-open-banking-institutions.component';

@Component({
  selector: 'app-apg-open-banking-affordability',
  templateUrl: './apg-open-banking-affordability.component.html',
  styleUrls: ['./apg-open-banking-affordability.component.scss']
})
export class ApgOpenBankingAffordabilityComponent implements OnInit {

  consent: string;
  header: string;
  accounts: ObAccountModel;
  mode: OpenBankingMode | 'premium' | 'days' | 'complete' = 'premium';
  institution: ObInstitutionModel;
  days: ObAffordabilityModel[];
  selectedDay: number;
  error: string;
  message: string;
  loading: boolean;
  premium: number;
  premiumQuestion: QQQuestionViewModel;

  constructor(
    private openBanking: OpenBankingService,
    private questionService: QuestionService
  ) { }

  ngOnInit() {
    this.error = null;
    this.premiumQuestion = this.questionService.createQuestion('Premium', 'Numeric', 'Enter your premium',
      { options: { placeholder: 'Premium (£)' } });
    this.premiumQuestion.answer = '50';
    this.mode = 'premium';
  }

  setPremium(premium: number) {
    this.premium = premium;
    this.mode = 'institutions';
  }

  async selectInstitution(institution: ObInstitutionModel) {
    try {
      this.loading = true;
      this.error = null;
      this.message = 'Waiting for authorization';
      const consent = await this.openBanking.getConsent(institution.id, "1234567890");
      this.institution = institution;
      if (consent)
        await this.loadAccounts(consent);
    }
    catch (err) {
      this.error = `Sorry, there was an error`;
    }
    this.message = null;
    this.loading = false;
  }

  async selectAccount(account: ObAccountModel) {
    try {
      this.loading = true;
      this.error = null;
      this.message = 'Checking affordability'
      this.days = await this.openBanking.getAffordability(account.id, this.consent, this.premium);
      this.mode = 'days';
      console.log(this.days);
    }
    catch (err) {
      logError('Error checking affordability', err);
      this.error = `Sorry, there was an error`;
      this.loading = false;
    }
    this.message = null;
    this.loading = false;
  }

  async loadAccounts(consent: string) {
    this.consent = consent;
    this.error = null;
    console.log('consent token %o', this.consent);
    try {
      this.accounts = await this.openBanking.getAccounts(this.consent, this.institution.id);
    }
    catch (err) {
      logError('Error loading accounts', err);
      this.error = `There was an error retrieving your accounts`;
    }
    this.mode = "accounts";
  }

  selectDay(day: number) {
    this.selectedDay = day;
    this.mode = 'complete';
  }
}
